import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import announcementImg from "../assets/img/agm-announcement.jpeg";

const Announcement = () => {
  useEffect(() => {
    document.title = "Announcement | Society of Aquaculture Professionals";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center">
          Announcement
        </h1>
        <p className="text-sm text-gray-600 mb-10 text-center leading-relaxed">
          Latest announcements from the Society of Aquaculture Professionals.
        </p>

        <div className="border border-gray-200 rounded-lg overflow-hidden shadow-sm">
          <img
            src={announcementImg}
            alt="Annual General Body Meeting - Society of Aquaculture Professionals"
            className="w-full h-auto block"
          />
        </div>

        <div className="mt-6 text-center">
          <a
            href={announcementImg}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-blue-700 underline"
          >
            View full size
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Announcement;
